'use strict';

exports.__esModule = true;
var ImageResizeMode = {
  center: 'center',
  contain: 'contain',
  cover: 'cover',
  none: 'none',
  repeat: 'repeat',
  stretch: 'stretch'
};

exports.default = ImageResizeMode;


// WEBPACK FOOTER //
// ./node_modules/react-native-web/dist/exports/Image/ImageResizeMode.js